<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <card>
        <el-table
          class="table-striped"
          :header-cell-style="headerCellStyle"
          header-row-class-name="text-danger text-center"
          highlight-current-row
          @current-change="handleCurrentChange"
          :cell-style="cellStyle"
          :data="agendas"
        >
          <el-table-column
            label="Meeting"
            prop="AgendaName"
          />
          <el-table-column
            label="Start"
            prop="StartDate"
            :formatter="dateFormatter"
            width="130px"
          />
          <el-table-column
            class-name="d-none d-md-table-cell"
            label="End"
            prop="EndDate"
            :formatter="timeFormatter"
            width="70px"
          />
          <el-table-column
            class-name="d-none d-md-table-cell"
            label="Location"
            prop="Location"
          />
          <el-table-column
            class-name="d-none d-md-table-cell"
            label="Notes"
            prop="Description"
          />
          <el-table-column
            class-name="d-none d-md-table-cell action-buttons td-actions"
            align="right"
            width="90"
            label="Actions"
          >
            <template slot-scope="props">
              <p-button
                type="info"
                size="sm"
                class="mt-1 mb-1"
                title="Edit"
                icon
                @click="showUpdateMeetingDialog(props.row)"
              >
                <i class="fa fa-edit" />
              </p-button>
              <p-button
                v-if="agendaTypeId === STAFF_DEVELOPMENT"
                type="danger"
                size="sm"
                class="mt-1 mb-1"
                title="Delete"
                icon
                @click="deleteConfirm(props.row)"
              >
                <i class="fa fa-times" />
              </p-button>
            </template>
          </el-table-column>
        </el-table>
        <p-button
          v-if="agendaTypeId === STAFF_DEVELOPMENT"
          type="success"
          :disabled="disableButtons"
          @click="showAddMeetingDialog"
        >
          Add Meeting
        </p-button>
      </card>
      <card v-if="agenda">
        <agenda-edit-item
          @new-end-time="onNewEndTime($event)"
          v-if="this.agenda"
          :agenda="agenda"
          :agenda-start-date="new Date(agenda.StartDate)"
        />
      </card>
      <modal
        :show.sync="showAdd"
        class="modal-primary"
        :show-close="false"
        header-classes="justify-content-center"
        type="mini"
      >
        <div
          slot="header"
          class="ml-4"
        >
          <h6>
            <i class="fa fa-edit mr-2" /><span class="text-danger">{{ newMeeting.AgendaName ? "Edit" : "Add" }} Meeting</span>
          </h6>
        </div>
        <ValidationObserver ref="theForm">
          <form
            @submit.prevent="save"
            id="theForm"
          >
            <ValidationProvider
              name="fullName"
              rules="required|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="fullName"
                :error="failed ? 'The meeting name is required': null"
                :has-success="passed"
                required
                label="Meeting Name"
                :disabled="agendaTypeId !== STAFF_DEVELOPMENT"
                placeholder=""
                max-length="255"
                v-model="newMeeting.AgendaName"
              />
            </ValidationProvider>
            <fg-input>
              <label for="datetime">Date & Time of Meeting</label>
              <el-date-picker
                v-model="newMeeting.StartDate"
                type="datetime"
                value-format="yyyy-MM-ddTHH:mm:ss"
                format="MM/dd/yyyy h:mm a"
                step="00:15"
              />
            </fg-input>
            <fg-input>
              <label for="datetime">End Time</label>
              <el-time-picker
                v-model="newMeeting.EndDate"
                format="h:mm a"
                value-format="yyyy-MM-ddTHH:mm:ss"
              />
            </fg-input>
            <fg-input
              name="location"
              label="Location"
              placeholder=""
              max-length="255"
              v-model="newMeeting.Location"
            />
            <fg-input>
              <label for="notes">Notes</label>
              <ValidationProvider
                name="notes"
                rules="required|max:2500"
                v-slot="{ passed, failed }"
              >
                <textarea
                  class="form-control"
                  :error="failed ? '2500 character max': null"
                  :has-success="passed"
                  maxlength="2500"
                  type="text"
                  placeholder=""
                  id="notes"
                  v-model="newMeeting.Description"
                />
              </ValidationProvider>
            </fg-input>
          </form>
        </ValidationObserver>
        <template slot="footer">
          <p-button
            type="danger"
            class="mr-2"
            @click="showAdd = false"
          >
            Cancel
          </p-button>
          <p-button
            type="success"
            native-type="submit"
            form="theForm"
            class="mr-2"
          >
            Save
          </p-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import agendaApi from '@/services/api/agenda'
import oops from '@/components/_main/oops.vue'
import AgendaEditItem from '@/components/agendas/agenda-item-edit.vue'
import Modal from '@/plugins/paper-components/modal.vue'
import { TimePicker } from 'element-ui'
import formatter from '@/services/formatter.js'

export default {
  name: 'AgendaEdit',
  components: {
    oops,
    Modal,
    AgendaEditItem,
    [TimePicker.name]: TimePicker
  },
  props: {
    agendaTypeId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      cellStyleStaffDev: { padding: '0', height: '20px', 'font-size': '10px', cursor: 'pointer' },
      headerCellStyleStaffDev: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      cellStyleCourse: { padding: '0', height: '20px', 'font-size': '9px' },
      headerCellStyleCourse: { padding: '0', height: '20px', 'font-size': '9px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      loading: true,
      errormessage: null,
      agenda: null,
      agendas: null,
      showAdd: false,
      newMeeting: {},
      disableButtons: false,
      tempHolding: null,
      updatingItem: {
        Duration: null,
        NewTime: null,
        Cascade: 'true'
      }
    }
  },
  computed: {
    headerCellStyle: function () {
      if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
        return this.headerCellStyleStaffDev
      } else if (this.agendaTypeId === this.COURSE_DAY) {
        return this.headerCellStyleCourse
      } else {
        return ''
      }
    },
    cellStyle: function () {
      if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
        return this.cellStyleStaffDev
      } else if (this.agendaTypeId === this.COURSE_DAY) {
        return this.cellStyleCourse
      } else {
        return ''
      }
    }
  },
  created () {
    this.STAFF_DEVELOPMENT = 1
    this.COURSE_DAY = 2
    this.OTHER = 3
  },
  mounted () {
    if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
      agendaApi.listStaffDevelopmentAgendas(this.$root.courseKey)
        .then(x => {
          this.agendas = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    } else if (this.agendaTypeId === this.COURSE_DAY) {
      agendaApi.listCourseDayAgendas(this.$root.courseKey)
        .then(x => {
          this.agendas = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    handleCurrentChange: function (row) {
      this.agenda = row
    },
    timeFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsTime(cellValue)
    },
    dateFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsDateTime(cellValue)
    },
    showAddMeetingDialog: function () {
      this.newMeeting = {
        AgendaType: 'Staff_Development',
        CourseKey: this.$root.courseKey,
        AgendaName: null,
        Description: null,
        EndDate: null,
        Id: null,
        Location: null,
        StartDate: null
      }
      this.showAdd = true
    },
    showUpdateMeetingDialog: function (row) {
      this.newMeeting = {
        AgendaType: 'Staff_Development',
        CourseKey: this.$root.courseKey,
        AgendaName: row.AgendaName,
        Description: row.Description,
        EndDate: row.EndDate,
        Id: row.Id,
        Location: row.Location,
        StartDate: row.StartDate
      }
      this.showAdd = true
    },
    save: function () {
      return this.$refs.theForm.validate().then(res => {
        if (this.newMeeting.AgendaName) {
          this.addMeeting()
        } else {
          this.updateMeeting()
        }
        return res
      })
    },
    addMeeting: function () {
      agendaApi.addNewAgenda(this.$root.courseKey, this.newMeeting)
        .then(x => {
          this.agendas = x
          this.showAdd = false
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error adding this agenda.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    updateMeeting: function (mtg) {
      agendaApi.updateAgenda(this.$root.courseKey, mtg)
        .then(x => {
          this.agendas = x
          if (mtg.Id !== null && mtg.Id !== 0) {
            for (let i = 0; i < x.length; i++) {
              if (x[i].Id === mtg.Id) {
                this.agenda = x[i]
                break
              }
            }
          }
          this.showAdd = false
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your agenda.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    deleteConfirm: function (row) {
      const msg2 = 'Are you sure you want to delete ' + row.AgendaName + '?  This will also delete all of the items associated with this meeting.'
      this.$confirm(msg2, {
        title: 'Are you sure?',
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.deleteAgenda(row)
      }).catch(() => {})
    },
    deleteAgenda: function (row) {
      this.disableButtons = true
      agendaApi.deleteAgenda(this.$root.courseKey, row.Id, this.STAFF_DEVELOPMENT)
        .then(x => {
          this.agendas = x
          this.agenda = null
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting your agenda.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
          this.disableButtons = false
        })
    },
    onNewEndTime: function (newTime) {
      this.agenda.EndDate =
        formatter.formatDateAndTimeAsIsoDateTime(this.agenda.StartDate, newTime)
      this.updateMeeting(this.agenda)
    }
  }
}
</script>
